import React, { ReactNode } from "react"

import { values } from "lodash"
import { useLocation } from "react-router-dom"

import { Header } from "../../components"
import { ROUTES } from "../../config/routes"
import { HEADER_VARIANTS } from "../../enums/variants"
import { RouteConfig } from "../../types/routes"

import "./style.scss"

const MainLayout = ({ children }: { children: ReactNode }) => {
  //const theme = useTheme()
  //const isResponsive = useMediaQuery(theme.breakpoints.down("md"))

  const location = useLocation()
  const path = location.pathname
  const routeConfig = values(ROUTES).find(
    (route): route is RouteConfig => route.path === path,
  )
  const headerVariant = routeConfig?.headerVariant ?? HEADER_VARIANTS.DEFAULT

  return (
    <div className={`main-layout header-${headerVariant}`}>
      <Header headerVariant={headerVariant} />
      {children}
    </div>
  )
}

export default MainLayout
